import { HealthZonesResponse } from '@viome/viome-base/src/usecase/Health/Health.model';

export const sortDataByRankAndTitle = (data: HealthZonesResponse) => {
  return data.sort((a, b) => {
    // First, compare by rank
    const rankComparison = a.rank.localeCompare(b.rank);
    if (rankComparison !== 0) {
      return rankComparison;
    }
    // If ranks are the same, compare by title
    return a.title.localeCompare(b.title);
  });
}